import React, { useEffect, useState } from 'react';

interface Skill {
  id: number;
  name: string;
}

interface SkillCategory {
  id: number;
  name: string;
}

export interface SkillCategoryData {
  category: SkillCategory;
  skills: Skill[];
}

export const Skills = ({
  togglePanel,
  formData,
  onFormDataChange,
  onSubmit,
  onNext,
  onBack,
  fetchData,
  loading,
  error,
  onSkillsLoad,
}: any) => {

  const [skills, setskills] = useState<SkillCategoryData[]>([]);
  const ids = [
    1, 2, 3, 5, 15, 17, 20, 32, 36, 37, 38, 39, 40, 41, 42, 43, 44, 48, 68, 69, 49, 50, 51, 61, 62, 63, 64, 65, 114, 66, 67, 109, 110, 107, 108, 105, 106, 82, 85, 87, 93, 94, 97, 99, 95, 96, 98, 100, 101, 102, 103, 104, 52, 53, 54, 55, 70, 71, 58, 59, 60, 74, 77, 80, 81, 75, 72, 115, 116, 121, 120, 123, 122, 178, 163, 180, 181, 182, 183, 179, 187, 191, 192
  ];

  useEffect(() => {
    const loadSkills = async () => {
      const query = new URLSearchParams({
        ...(formData.occupations?.length ? { occupations: formData.occupations.join(',') } : {}),
        ids: ids.join(','),
      }).toString();

      const data = await fetchData(`/api/v1/user_skill_master?${query}`);
      if (data) {
        setskills(data);
        if (onSkillsLoad) {
          onSkillsLoad(data);
        }
      }
    };

    loadSkills();

  }, []);

  const handleCheckboxChange = (id: number) => {
    const updated = formData.skills.includes(id)
      ? formData.skills.filter((skillId: number) => skillId !== id)
      : [...formData.skills, id];
    onFormDataChange('skills', updated);
  };

  return (
    <div className="p-searchPanel">

      <div className="p-searchPanel__header">
        <div className="p-searchPanel__title">検索条件（スキル）2/3</div>
        <button
          className="p-searchPanel__closeButton"
          onClick={togglePanel}
        ></button>
      </div>

      {loading && <div>ロード中...</div>}
      {error && <div style={{ color: "red" }}>{error}</div>}

      <div className="p-searchPanel__section">
        {skills.map((category) => (
          <div key={category.category.id}>
            <div className="p-searchPanel__section__title">
              {category.category.name}
            </div>
            <div className="p-searchPanel__section__items">
              {category.skills.map((skill) => (
                <div key={skill.id}>
                  <input
                    type="checkbox"
                    id={`skill_${skill.id}`}
                    className="c-formItem__checkbox"
                    checked={formData.skills.includes(skill.id)}
                    onChange={() => handleCheckboxChange(skill.id)}
                  />
                  <label
                    htmlFor={`skill_${skill.id}`}
                    className="c-formItem__label -hasChedkbox"
                  >
                    {skill.name}
                  </label>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="p-searchPanel__buttons">
        <button
          className="p-searchPanel__actionButton p-searchPanel__actionButton--back"
          onClick={onBack}
        >戻る</button>
        <button
          className="p-searchPanel__searchButton"
          onClick={onSubmit}
        >
          <span>検索</span>
          <img
            src="/asset/img/common/magnifying-glass-white.svg"
            alt="検索アイコン"
            className="p-searchPanel__searchButton__icon"
          />
        </button>
        <button
          className="p-searchPanel__actionButton p-searchPanel__actionButton--next"
          onClick={onNext}
        >次へ</button>
      </div>
    </div>
  );
};
